import { render } from "./SortableTh.vue?vue&type=template&id=528de8e3&ts=true"
import script from "./SortableTh.ts?vue&type=script&lang=ts&external"
export * from "./SortableTh.ts?vue&type=script&lang=ts&external"

import "./SortableTh.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__